// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_1410bfd27b--arrow--xQwqy"};